import store from "@/store";


export default {

  setShipHeroShipmentResults({ commit }, result) {
    const shipHeroResults = store.getters["orders/getShipHeroShipmentResults"];
    shipHeroResults.push(result);
    commit("SET_SHIPHERO_RESULTS", shipHeroResults);
  },

  activateQuickEdit({ commit }) {
    commit("setQuickEditActive", true);
  },
  deactivateQuickEdit({ commit }) {
    commit("setQuickEditActive", false);
  },
  

};
